export class Invoice {
  branchid?: number
  branchname?: string
  branchregistercode?: string
  branchaddress?: string
  invoiceid?: number
  orderid?: number
  serial?: number
  docnum?: string
  name?: string
  registercode?: string
  xplaceid?: string
  addressfull?: string
  pagecode?: string
  minutaid?: number
  modid?: number
  xmodid?: string
  grossweight?: number
  quantity?: number
  volumes?: number
  obsexp?: string
  obsnot?: string
}

export class InvoiceItem {
  invoiceid?: number
  productid?: number
  shortname?: string
  src?: string
  quantity?: number
  grossweight?: number

}

